/**
 * @generated SignedSource<<b1de857a681a3de22b13e01932446844>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerpsPoolBalanceReinvestFragment$data = {
  readonly availableYieldLp: {
    readonly amount: bigint;
  };
  readonly availableYieldXlp: {
    readonly amount: bigint;
  };
  readonly id: string;
  readonly " $fragmentType": "PerpsPoolBalanceReinvestFragment";
};
export type PerpsPoolBalanceReinvestFragment$key = {
  readonly " $data"?: PerpsPoolBalanceReinvestFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PerpsPoolBalanceReinvestFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PerpsPoolBalanceReinvestFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Balance",
      "kind": "LinkedField",
      "name": "availableYieldLp",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Balance",
      "kind": "LinkedField",
      "name": "availableYieldXlp",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "PerpsAccount",
  "abstractKey": null
};
})();

(node as any).hash = "ff27e602eaa3e58d0485dd3535542a73";

export default node;
